module.exports = __webpack_public_path__ + "img/SRC-RKD-PLUS.70241e5a.png";